import { Icons } from '@icons/icons';

import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EHistoryParametersTabsName = {
	Chart: 'Chart',
	Table: 'Table',
} as const;

export type THistoryParametersTabsName = TValueOfStringRecord<typeof EHistoryParametersTabsName>

export const historyParametersTabs = [
	{
		value: EHistoryParametersTabsName.Chart,
		icon: Icons.kpiIconOutline,
		activeIcon: Icons.kpiIcon,
	},
	{
		value: EHistoryParametersTabsName.Table,
		icon: Icons.tableIcon,
		activeIcon: Icons.tableIconActive,
	},
];
